import { cacheFirstConfig, http } from '@/core/helpers/http.helper';
import { LocationQuery } from 'vue-router';
import { ApiResource } from './../../models/api-resource.interface';
import { SectorType } from './sector-type.interface';

export class SectorTypeService {
   async getSectorTypes(query?: LocationQuery) {
      const response = await http.get<ApiResource<Array<SectorType>>>(`/sector-types`, { ...cacheFirstConfig, params: { ...query } });
      return response.data;
   }
}
